import { ProductInterface } from "../../interfaces/product";
import { ProductFilterType, ProductFilters } from "../ProductFilterContext";

export const createInitialProductFilters = (
  enabledFilters: ProductFilterType[],
  products: ProductInterface[]
) => {
  const dedupedEnabledFilters = [...new Set(enabledFilters)];
  const initialFilters: ProductFilters = {
    categories: dedupedEnabledFilters.includes("categories")
      ? [
          ...new Set(
            products.flatMap(product =>
              product.categories.map(category => category.id)
            )
          )
        ]
      : [],
    brands: dedupedEnabledFilters.includes("brands")
      ? products.map(product => product.brand.id)
      : []
  };
  return initialFilters;
};
